import { render } from "./a_baal.vue?vue&type=template&id=3a063c2d"
import script from "./a_baal.vue?vue&type=script&lang=js"
export * from "./a_baal.vue?vue&type=script&lang=js"

import "./a_baal.vue?vue&type=style&index=0&id=3a063c2d&lang=less"
script.render = render

export default script